<template>
	<el-drawer size="800px" title="基础设置" :visible.sync="dialogVisible" :modal-append-to-body="false" :wrapperClosable="false"
		class="customer-drawer-common wechat-basic">
		<div>
			<h1>微信公众号/ 小程序接入</h1>
			<el-form ref="form" :model="form" :rules="formRules" label-width="150px">
				<el-form-item label="类型：" prop="type">
					 <el-radio-group v-model="form.type" :disabled="operateType == 'edit'">
					    <el-radio label="1">公众号</el-radio>
					    <el-radio label="2">小程序</el-radio>
					 </el-radio-group>
				</el-form-item>
				<el-form-item label="公众号/APP名称：" prop="appname">
					<el-input placeholder="请输入公众号/APP名称：" v-model="form.appname" clearable>
					</el-input>
				</el-form-item>
				<el-form-item label="ID：">
					<el-input placeholder="请输入ID" v-model="form.id" clearable disabled>
					</el-input>
				</el-form-item>
				<el-form-item label="授权品牌：" prop="brand">
					<el-select v-model="form.brand" clearable placeholder="请选择授权品牌" @change="onBrandChange">
						<el-option v-for="item in brand_options" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="技能组：" prop="skillGroup">
					<el-select v-model="form.skillGroup" clearable placeholder="请选择技能组">
						<el-option v-for="item in skillGroup_options" :key="item.skillId" :label="item.skillName"
							:value="item.skillId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="消息处理模式：" prop="messageHandleType">
					<el-checkbox-group v-model="form.messageHandleType" class="column-checkbox">
						<el-checkbox label="Test" disabled><span class="text">授权</span></el-checkbox>
						<el-checkbox label="Forward"><span class="text">普通模式</span>所有消息 全部转接至OCS+</el-checkbox>
						<el-checkbox label="Keyword"><span class="text">关键词模式</span>触发关键词的聊天转接至OCS+</el-checkbox>
						<el-checkbox label="MenuEvent"><span class="text">事件模式</span>触发菜单按钮的聊天转接至OCS+</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
			</el-form>
		</div>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</el-drawer>

</template>

<script>
	import {mapGetters,mapState} from 'vuex'
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList',
				'skillGroupLists'
			]),
		},
		data() {
			return {
				dialogVisible:false,
				loading: false,
				skillGroup_options: [],
				brand_options: [],
				operateType:'add',
				row_data:'',
				form: {
					appname: '',
					id: '',
					brand: '',
					skillGroup: '',
					messageHandleType: ['Test'],
					type:'1'
				},
				formRules: {
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],
					appname: [{
						required: true,
						message: '请输入公众号/APP名称',
						trigger: 'blur'
					}],
					brand: [{
						required: true,
						message: '请选择品牌',
						trigger: 'change'
					}],
					skillGroup: [{
						required: true,
						message: '请选择技能组',
						trigger: 'change'
					}],
					messageHandleType: [{
						required: true,
						message: '请选择消息处理模式',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			onSave() {
				let params = JSON.parse(JSON.stringify(this.form));
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true
						params.messageHandleType = this.form.messageHandleType.join(',');
						if(this.operateType == 'add') {
							this.$api.createWechatSyatemId().then(res => {
								params.id = res.data;
								this.loading = false;
								this.$api.wechatSystemAdd(params).then(res => {
									this.$message.success('添加成功');
									this.dialogVisible = false;
									this.$emit('getList')
								})
							})
						}else {
							this.$api.updateWechatSystemBasic({
								  "appid": this.row_data.appid,
								  "brand": this.form.brand,
								  "skillGroup": this.form.skillGroup,
								  "channel": this.form.type,
								  "sourceBrand": this.row_data.appidConfig.grantBrand,
								  "sourceSkillGroup": this.row_data.appidConfig.grantSkillgroup
							}).then(res => {
								this.loading = false;
								if(res.errcode == 0) {
									params.imUrl = res.data.imUrl;
									this.$api.wechatSystemEdit(params).then(res => {
										this.$message.success('编辑成功');
										this.dialogVisible = false;
										this.$emit('getList')
									})
								}
							})
							
						}
						
					}
				})
			},
			openBasic(data){
				this.dialogVisible = true;
				this.getSkillGroup(data);
				this.row_data = JSON.parse(JSON.stringify(data));
				this.$nextTick(() => {
					if(data){
						this.operateType = 'edit';
						Object.keys(this.form).map(item => {
							this.form[item] = data[item]
						})
						this.form.messageHandleType = data.messageHandleType ?  data.messageHandleType.split(',') : ['Test'];
						this.form.messageHandleType.includes('Test') ? this.form.messageHandleType : this.form.messageHandleType.push('Test');
						this.form.brand = data.appidConfig?.grantBrand;
					}else{
						this.operateType = 'add';
						this.$refs.form.resetFields()
						this.form.id = ''
					}
				})
				
			},
			getSkillGroup(data){
				let result = [];
				this.$api.getWechatSystemSkillGroup({brand:data.appidConfig?.grantBrand,appid:data.appid}).then(res => {
					// if(this.skillGroupLists.length > 0){
					// 	this.skillGroupLists.map(item => {
					// 		if(data.appidConfig && data.appidConfig.grantSkillgroup == item.id){
					// 			result.push({skillId:item.id,skillName:item.name});
					// 			return
					// 		}
					// 	})
						
					// }
					this.skillGroup_options = res.data;
					this.form.skillGroup = data.appidConfig.grantSkillgroup || ''
				})
			},
			onBrandChange(val){
				if(val){
					this.row_data.appidConfig.grantBrand = val;
					this.getSkillGroup(this.row_data)
				}else{
					this.skillGroup_options = [];
				}
			}
		},
		async mounted() {
			this.brand_options= await this.subBrandList;
			
		}
	}
</script>

<style lang="scss" scoped>
	.wechat-basic {
		font-size: 14px;

		h1 {
			color: #3C4353;
			font-size: 14px;
			margin: 20px 0;
			padding-left: 20px;
		}

		.column-checkbox {
			display: flex;
			flex-direction: column;

			.text {
				display: inline-block;
				width: 100px;
			}

			.tips {
				color: #A6AAB8;
				margin-left: 40px;

				mark {
					background-color: #fff;
					// color: #337EFF;
					color: #A6AAB8;
				}
			}
		}

		.footer {
			display: flex;
			justify-content: flex-end;
			margin-top: 50px;
		}
	}
</style>
